import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatChipsModule} from '@angular/material/chips';
import {MatDialogModule} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {RouterModule} from '@angular/router';
import {AddRemoveTagComponent} from './add-remove-tag/add-remove-tag.component';
import {MultiEditDialogComponent} from './multi-edit-dialog/multi-edit-dialog.component';
import {TagInputComponent} from './tag-input/tag-input.component';
import {TagPickerComponent} from './tag-picker/tag-picker.component';
import {TagService} from './tag.service';
import {TagComponent} from './tag/tag.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatIconModule,
        MatButtonModule,
        MatInputModule,
        MatAutocompleteModule,
        MatChipsModule,
        MatDialogModule,
        RouterModule,
        MatCardModule,
        MatSlideToggleModule,
        TagComponent,
        TagInputComponent,
        TagPickerComponent,
        MultiEditDialogComponent,
        AddRemoveTagComponent,
    ],
    providers: [TagService],
    exports: [TagComponent, TagInputComponent, TagPickerComponent],
})
export class TagModule {
    constructor(private tagService: TagService) {}
}
